import { render, staticRenderFns } from "./WeicaiVisitor.vue?vue&type=template&id=5a80da52&scoped=true&"
import script from "./WeicaiVisitor.vue?vue&type=script&lang=js&"
export * from "./WeicaiVisitor.vue?vue&type=script&lang=js&"
import style0 from "./WeicaiVisitor.vue?vue&type=style&index=0&id=5a80da52&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a80da52",
  null
  
)

export default component.exports